module.exports = __webpack_public_path__ + "media/categories/4011-885936fc.svg";